import { useContext } from "react";
import { WrapperContext } from "../context/WrapperContext";

const useWrapper = () => {
  return useContext(WrapperContext);
}

export default useWrapper;
